<script setup lang="ts">
defineProps<{
  customerDetailsTitle: string;
}>();
const { siteOptions } = useSiteOptions();
</script>

<template>
  <div id="checkout" class="space-y-8">
    <h1 class="h1 text-primary">
      Passer une commande
    </h1>
    <div class="flex flex-col gap-8 lg:flex-row">
      <form name="checkout" method="post" :action="siteOptions.checkout_url" enctype="multipart/form-data" aria-label="Commander" class="checkout space-y-16">
        <CheckoutStepCustomer />
        <CheckoutStepOrderReview />
        <CheckoutCoupon />
        <CheckoutStepPayment>
          <slot name="payment" />
        </CheckoutStepPayment>
      </form>
    </div>
  </div>
</template>
